import { FC } from "react"

import StatusTag from "components/StatusTag/StatusTag"
import i18n from "intl/i18n"
import { AssetMaintenanceStatus } from "models/AssetMaintenance"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"

function getBgColorClass(status: AssetMaintenanceStatus) {
    return {
        [AssetMaintenanceStatus.scheduled]: 'bg-grey-400',
        [AssetMaintenanceStatus.pending]: 'bg-yellow-500',
        [AssetMaintenanceStatus.overdue]: 'bg-red-400',
        [AssetMaintenanceStatus.completed]: 'bg-green-400',
    }[status] || 'bg-grey-400'
}

export function getMaintenanceStatusLabel(status: AssetMaintenanceStatus) {
    return {
        [AssetMaintenanceStatus.scheduled]: i18n.t('maintenance.status.scheduled'),
        [AssetMaintenanceStatus.pending]: i18n.t('maintenance.status.pending'),
        [AssetMaintenanceStatus.overdue]: i18n.t('maintenance.status.overdue'),
        [AssetMaintenanceStatus.completed]: i18n.t('maintenance.status.completed'),
    }[status] || status
}

interface IAssetMaintenanceStatusTagProps {
    status: AssetMaintenanceStatus
}

const AssetMaintenanceStatusTag: FC<IAssetMaintenanceStatusTagProps> = ({
    status,
}) => {
    const text = getMaintenanceStatusLabel(status)
    const bgColorClass = getBgColorClass(status)
    return (
        <StatusTag className={bgColorClass}>
            <FlexibleContent text={text} />
        </StatusTag>
    )
}

export default AssetMaintenanceStatusTag
